'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _handleActions;

import { handleActions } from 'flux-actions';
import { List } from 'immutable';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
import LegalConsentOptions from 'MeetingsBase/models/LegalConsentOptions';
import LegalCommunicationConsent from 'MeetingsLib/models/LegalCommunicationConsent';
import { CHECKBOX_KEYS } from 'MeetingsBase/constants/legalConsent';
var initialState = List();
export default handleActions((_handleActions = {}, _defineProperty(_handleActions, ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, function (state, action) {
  if (state.size === 0) {
    var legalConsentOptions = LegalConsentOptions.from(action.payload.bookInfo.customParams.legalConsentOptions);
    var subscriptions = legalConsentOptions.getSubscriptions();
    return subscriptions.map(function (subscription) {
      var _LegalCommunicationCo;

      return new LegalCommunicationConsent((_LegalCommunicationCo = {}, _defineProperty(_LegalCommunicationCo, CHECKBOX_KEYS.COMMUNICATION_TYPE_ID, subscription.communicationTypeId), _defineProperty(_LegalCommunicationCo, "consented", false), _defineProperty(_LegalCommunicationCo, "required", subscription.required), _LegalCommunicationCo));
    });
  }

  return state;
}), _defineProperty(_handleActions, ActionTypes.SET_GIVEN_CONSENT, function (state, action) {
  var indexToUpdate = state.findIndex(function (checkbox) {
    return checkbox[CHECKBOX_KEYS.COMMUNICATION_TYPE_ID] === action[CHECKBOX_KEYS.COMMUNICATION_TYPE_ID];
  });
  return state.setIn([indexToUpdate, 'consented'], action.consented);
}), _defineProperty(_handleActions, ActionTypes.RESET_CONSENT_RESPONSES, function (state) {
  return state.map(function (checkbox) {
    return checkbox.set('consented', false);
  });
}), _handleActions), initialState);